export const configPermissions = {
    PAVE_CHECKIN_CONFIG: {
        key: 'Config.PaveCheckin',
        name: 'View and edit pave configuration'
    }
}